// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { miniMyAccountStyles } from "@keller/App/Components/MiniMyAccount/MiniMyAccount";
import { color, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.container = {
    css: css`
        min-width: 480px;
        ${xScreen("lte", "md")} {
            min-width: 250px;
        }
    `,
};

miniMyAccountStyles.title = {
    variant: "h5",
    css: css`
        margin-bottom: 20px;
    `,
};

miniMyAccountStyles.subtitle = {
    variant: "h6",
    css: css`
        padding-bottom: 5px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 10px;
    `,
};

miniMyAccountStyles.linkListContainer = {
    css: css`
        margin-bottom: 24px;
    `,
};

miniMyAccountStyles.linkItemsSubContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        line-height: 19px;

        ${xScreen("lte", "xs")} {
            grid-template-columns: 1fr;
        }
    `,
};

miniMyAccountStyles.linkItem = {
    color: "text",
    typographyProps: {
        size: 12,
        lineHeight: "18px",
    },
    css: css`
        align-self: baseline;
    `,
};

miniMyAccountStyles.profileContainer = {
    css: css`
        margin-bottom: 24px;
    `,
};

miniMyAccountStyles.profileSubContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(146px, auto));
        gap: 16px 20px;
    `,
};

miniMyAccountStyles.profileItemContainer = {
    css: css`
        max-width: 146px;
        width: 100%;
    `,
};

miniMyAccountStyles.profileTitle = {
    variant: "h6",
    css: css`
        margin-bottom: 8px;
    `,
};

miniMyAccountStyles.profileSubTitle = {
    size: 12,
    weight: "normal",
    css: css`
        letter-spacing: 0;
        line-height: 18px;
        display: block;
        white-space: break-spaces;
    `,
};

miniMyAccountStyles.profileContactTypography = {
    color: "primary",
    size: 12,
    weight: "normal",
    css: css`
        white-space: normal;
        align-items: flex-start;
        margin-bottom: 10px;
        &:hover {
            color: ${color("common.ui1")};
        }
    `,
};

miniMyAccountStyles.actionContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};

miniMyAccountStyles.changeCustomerButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-top: 20px;
    `,
};

miniMyAccountStyles.signOutButton = {
    mergeCss: true,
    variant: "tertiary",
    css: css`
        display: flex;
        align-items: center;
        margin-top: 20px;
        margin-left: auto;
        padding: 8px 0;
        font-size: 14px;
        font-weight: bold;
        ${xScreen("lt", "sm")} {
            margin-left: initial;
            flex-direction: row-reverse;
            justify-content: center;
        }

        ${IconWrapper} {
            color: ${color("primary")};
            opacity: 0.55;
            margin-right: 8px;
            top: 0;
            ${xScreen("lt", "sm")} {
                margin-right: 0;
                margin-left: 8px;
            }
        }

        &:hover {
            color: ${color("common.ui1")};
            ${IconWrapper} {
                color: ${color("common.ui1")};
                opacity: 1;
            }
        }
    `,
};
